import { store } from 'src/App'
import { closeDialog } from 'src/redux/slices/alertDialog'

export const handleCloseDialog = () => {
  store.dispatch(closeDialog())
}
